"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ApiAuthorizationConstants_1 = require("../components/api-authorization/ApiAuthorizationConstants");
var Responses;
(function (Responses) {
    Responses["success"] = "success";
    Responses["alreadyExists"] = "alreadyExists";
    Responses["serverError"] = "serverError";
    Responses["frontEndError"] = "frontendError";
    Responses["connectionError"] = "conenctionError";
    Responses["unknown"] = "unknown";
})(Responses || (Responses = {}));
function CreatePortfolioSaver(allocationData, feeAlphaData, ssChoiceData, userData, setUserData) {
    var _this = this;
    return function (portfolioName, callback) { return __awaiter(_this, void 0, void 0, function () {
        var finalResult, alreadyExists, newPortfolio_1, portfolioString, portfolioDetail, timer, e_1, messages;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    finalResult = Responses.unknown;
                    alreadyExists = userData.portfolioData.find(function (portfolio) { return portfolio.portfolioName == portfolioName; });
                    if (!!alreadyExists) return [3 /*break*/, 6];
                    newPortfolio_1 = {
                        ownerId: "",
                        portfolioName: portfolioName,
                        fee: feeAlphaData.additionalComparisonFees || 0,
                        alpha: feeAlphaData.additionalComparisonAlpha || 0,
                        smartshieldSelection: ssChoiceData.smartShieldChoice,
                        smartshieldValue: ssChoiceData.smartShieldChoiceValue || 0,
                        australianEquity: allocationData.australianEquityWeight || 0,
                        intlEquityHedged: allocationData.intlEquityHedgedWeight || 0,
                        intlEquityUnhedged: allocationData.intlEquityUnhedgedWeight || 0,
                        auGovFixedIncome: allocationData.auGovFixedIncomeWeight || 0,
                        auCorpFixedIncome: allocationData.auCorpFixedIncomeWeight || 0,
                        intlGovFixedIncome: allocationData.intlGovFixedIncomeWeight || 0,
                        auListedProperty: allocationData.auListedPropertyWeight || 0,
                        auDirectProperty: allocationData.auDirectPropertyWeight || 0,
                        australianCash: allocationData.australianCashWeight || 0
                    };
                    portfolioString = JSON.stringify(newPortfolio_1);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(ApiAuthorizationConstants_1.ApplicationPaths.AddPortfolio, {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json; charset=utf-8'
                            },
                            body: portfolioString // body data type must match "Content-Type" header
                        })];
                case 2:
                    portfolioDetail = _a.sent();
                    timer = new Promise(function (resolve, reject) {
                        setTimeout(reject, 5000);
                    });
                    return [4 /*yield*/, Promise.race([portfolioDetail, timer]).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            var serverResponse, userDataClone;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, result.json()];
                                    case 1:
                                        serverResponse = _a.sent();
                                        if (serverResponse.result === "success") {
                                            userDataClone = __assign({}, userData);
                                            userDataClone.portfolioData.push(newPortfolio_1);
                                            setUserData(userDataClone);
                                            callback && callback();
                                            return [2 /*return*/, Responses.success];
                                        }
                                        else {
                                            return [2 /*return*/, Responses.serverError];
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); }, function () {
                            return Responses.connectionError;
                        })];
                case 3:
                    finalResult = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    finalResult = Responses.frontEndError;
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 7];
                case 6:
                    finalResult = Responses.alreadyExists;
                    _a.label = 7;
                case 7:
                    messages = {};
                    messages[Responses.success] = "success";
                    messages[Responses.alreadyExists] = "A portfolio with this name already exists.  Try another name.";
                    messages[Responses.frontEndError] = "An error has occured with our website.  Portfolio not saved.";
                    messages[Responses.serverError] = "An error has occured in our server.  Portfolio not saved.";
                    messages[Responses.connectionError] = "Could not connect to our server. Portfolio not saved.";
                    messages[Responses.unknown] = "Something went wrong while trying to save this portfolio.";
                    return [2 /*return*/, { isSuccess: finalResult === Responses.success, message: messages[finalResult] }];
            }
        });
    }); };
}
exports.default = CreatePortfolioSaver;
//# sourceMappingURL=CreatePortfolioSaver.js.map